var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 12C5.625 10.8109 5.95261 9.69704 6.52177 8.74328V4.69759H2.47608C0.870375 6.78297 0 9.32448 0 12C0 14.6755 0.870375 17.2171 2.47608 19.3024H6.52177V15.2567C5.95261 14.303 5.625 13.1891 5.625 12Z",
    fill: "#FBBD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.375L9.1875 21.1875L12 24C14.6756 24 17.217 23.1296 19.3024 21.5239V17.4826H15.261C14.2989 18.0538 13.1804 18.375 12 18.375Z",
    fill: "#0F9D58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52176 15.2567L2.47607 19.3024C2.79398 19.7153 3.14015 20.1107 3.51473 20.4853C5.78123 22.7518 8.79468 24 12 24V18.375C9.67387 18.375 7.63514 17.1225 6.52176 15.2567Z",
    fill: "#31AA52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 11.2699 23.9339 10.5385 23.8035 9.82609L23.698 9.24958H12V14.8746H17.6931C17.1402 15.9743 16.2902 16.8715 15.261 17.4826L19.3024 21.524C19.7153 21.2061 20.1106 20.8599 20.4853 20.4853C22.7518 18.2188 24 15.2053 24 12Z",
    fill: "#3C79E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5078 7.49217L17.005 7.98933L20.9825 4.01189L20.4853 3.51473C18.2188 1.24823 15.2054 0 12 0L9.1875 2.8125L12 5.625C13.7028 5.625 15.3037 6.28809 16.5078 7.49217Z",
    fill: "#CF2D48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.625V0C8.79473 0 5.78128 1.24823 3.51473 3.51469C3.14015 3.88927 2.79398 4.28466 2.47607 4.69758L6.52176 8.74327C7.63519 6.8775 9.67392 5.625 12 5.625Z",
    fill: "#EB4132"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmailIcon.952bf90ac6ce949199dba7012355971e.svg";
export { ForwardRef as ReactComponent };